import PDFDocument from "pdfkit/js/pdfkit.standalone"
import SVGtoPDF from "svg-to-pdfkit"
import blobStream from "blob-stream"
import { ComputedData } from "./Models"

export const downloadPDF = (
  svg: SVGSVGElement,
  computedData: ComputedData,
  docHeight: number
) => {
  const doc = new PDFDocument({ size: "A4", layout: "landscape" })
  const scaleFactor = Math.min(
    doc.page.width / computedData.allBox.w,
    doc.page.height / computedData.allBox.h
  )
  const scaledHeight = docHeight * scaleFactor

  SVGtoPDF(doc, svg, 0, 0, {
    useCSS: true,
    preserveAspectRatio: "xMidYMid meet",
    height: scaledHeight,
  })
  doc.end()

  const stream = doc.pipe(blobStream())
  stream.on("finish", () => {
    const blob = stream.toBlob()
    const url = window.URL.createObjectURL(blob)
    const alink = document.createElement("a")
    alink.download = "forbinSolution.pdf"
    alink.href = url
    alink.click()
    window.URL.revokeObjectURL(url)
  })
}

const setSVGViewboxUnitsToMM = (svg: SVGElement) => {
  const viewBox = svg.getAttribute("viewBox")!
  const [w, h] = [viewBox.split(" ")[2], viewBox.split(" ")[3]]
  svg.removeAttribute("viewBox")
  svg.setAttribute("width", `${w}mm`)
  svg.setAttribute("height", `${h}mm`)
}

const setSVGElemUnitsToMM = (svg: SVGElement) => {
  if (!svg) return

  const width = svg.getAttribute("width")
  const height = svg.getAttribute("height")
  const x = svg.getAttribute("x")
  const y = svg.getAttribute("y")
  const rx = svg.getAttribute("rx")

  if (width !== null) svg.setAttribute("width", `${width}mm`)
  if (height !== null) svg.setAttribute("height", `${height}mm`)
  if (x !== null) svg.setAttribute("x", `${x}mm`)
  if (y !== null) svg.setAttribute("y", `${y}mm`)
  if (rx !== null) svg.setAttribute("rx", `${rx}mm`)
}

export const generateSVG = (
  svg: SVGSVGElement,
  w: number,
  h: number
): SVGSVGElement => {
  const clonedSVG = svg.cloneNode(true) as SVGSVGElement

  const classNamesToRemove = ["area", "allbox", "boundingBox", "allbox2"]

  classNamesToRemove.forEach((className) => {
    clonedSVG.querySelectorAll(`.${className}`).forEach((el) => el.remove())
  })

  const tagsToRemove = ["text", "pattern"]
  tagsToRemove.forEach((tagName) => {
    clonedSVG.querySelectorAll(tagName).forEach((el) => el.remove())
  })
  clonedSVG
    .querySelectorAll("rect")
    .forEach((elem) => setSVGElemUnitsToMM(elem))
  setSVGViewboxUnitsToMM(clonedSVG)
  clonedSVG.setAttribute("viewbox", `0 0 ${w} ${h}`)
  return clonedSVG
}

export const downloadSVG = (svg: SVGSVGElement) => {
  const serializer = new XMLSerializer()
  const svgData = serializer.serializeToString(svg)
  const blob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" })

  const url = URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.download = "exported.svg"

  document.body.appendChild(link)
  link.click()

  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
